import { useSyncExternalStore } from 'react';

export type ToastTone = 'accent' | 'ok' | 'warn' | 'danger';

export interface ToastMessage {
  id: string;
  message: string;
  tone: ToastTone;
}

let toasts: ToastMessage[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeToasts(callback: () => void): () => void {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getToasts(): ToastMessage[] {
  return toasts;
}

export function dismissToast(id: string): void {
  toasts = toasts.filter((toast) => toast.id !== id);
  emit();
}

export function pushToast(message: string, tone: ToastTone = 'accent', duration = 3200): string {
  const id = crypto.randomUUID();
  toasts = [...toasts, { id, message, tone }].slice(-3);
  emit();
  window.setTimeout(() => dismissToast(id), duration);
  return id;
}

export function useToasts(): ToastMessage[] {
  return useSyncExternalStore(subscribeToasts, getToasts, () => []);
}
